import { CheckIcon } from '@phosphor-icons/react';
import { useEffect, useRef } from 'react';

import type { SubmissionReceipt } from '@/application/brief/BriefGateway';
import { useContent } from '@/content/ContentContext';
import { Button } from '@/ui/Button/Button';

import styles from './Brief.module.css';

interface BriefSuccessProps {
  readonly receipt: SubmissionReceipt;
  readonly fullName: string;
  readonly email: string;
  readonly onRestart: () => void;
}

export function BriefSuccess({ receipt, fullName, email, onRestart }: BriefSuccessProps) {
  const { brief } = useContent();
  const titleRef = useRef<HTMLHeadingElement>(null);
  const firstName = fullName.trim().split(/\s+/)[0] ?? fullName;

  useEffect(() => {
    titleRef.current?.focus({ preventScroll: true });
  }, []);

  return (
    <div className={styles.success} role="status">
      <span className={styles.successIcon} aria-hidden="true">
        <CheckIcon size={24} weight="regular" />
      </span>
      <h3 ref={titleRef} className={styles.successTitle} tabIndex={-1}>
        {brief.success.title(firstName)}
      </h3>
      <p className={styles.direct}>{brief.success.body(email.trim().toLowerCase())}</p>
      {receipt.reference !== 'ignored' && (
        <p className={styles.reference}>{brief.success.reference(receipt.reference)}</p>
      )}
      <Button variant="quiet" icon="none" onClick={onRestart}>
        {brief.actions.restart}
      </Button>
    </div>
  );
}
